export default __webpack_public_path__ + "static/media/paymongo-logo.e5c3fa77.png";